import { render } from "./NavigationView.vue?vue&type=template&id=4787e850"
import script from "./NavigationView.vue?vue&type=script&lang=js"
export * from "./NavigationView.vue?vue&type=script&lang=js"

import "./NavigationView.vue?vue&type=style&index=0&id=4787e850&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__